export const FETCH_CUSTOM_REPORTS_LIST_ADMIN = 'FETCH_CUSTOM_REPORTS_LIST_ADMIN';
export const FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS = 'FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS';
export const FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE = 'FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE';

export const FETCH_CUSTOM_REPORTS_PARAMS_ADMIN = 'FETCH_CUSTOM_REPORTS_PARAMS_ADMIN';
export const FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS = 'FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS';
export const FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE = 'FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE';

export const RESET_CUSTOM_REPORTS_PARAMS_ADMIN = 'RESET_CUSTOM_REPORTS_PARAMS_ADMIN';

export const RESET_CUSTOM_REPORT_TO_EDIT_ADMIN = 'RESET_CUSTOM_REPORT_TO_EDIT_ADMIN';

export const HIDE_CUSTOM_REPORT_FORM_ADMIN = 'HIDE_CUSTOM_REPORT_FORM_ADMIN';

export const UPDATE_DISPLAY_FLAG_ADMIN = 'UPDATE_DISPLAY_FLAG_ADMIN';
export const UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS = 'UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS';
export const UPDATE_DISPLAY_FLAG_ADMIN_FAILURE = 'UPDATE_DISPLAY_FLAG_ADMIN_FAILURE';

export const SAVE_CUSTOM_REPORT_ADMIN = 'SAVE_CUSTOM_REPORT_ADMIN';
export const SAVE_CUSTOM_REPORT_ADMIN_SUCCESS = 'SAVE_CUSTOM_REPORT_ADMIN_SUCCESS';
export const SAVE_CUSTOM_REPORT_ADMIN_FAILURE = 'SAVE_CUSTOM_REPORT_ADMIN_FAILURE';

export const SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN = 'SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN';

export const SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN = 'SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN';

export const SELECT_CUSTOM_REPORT_ADMIN = 'SELECT_CUSTOM_REPORT_ADMIN';

export const DELETE_CUSTOM_REPORT_ADMIN = 'DELETE_CUSTOM_REPORT_ADMIN';
export const DELETE_CUSTOM_REPORT_ADMIN_SUCCESS = 'DELETE_CUSTOM_REPORT_ADMIN_SUCCESS';
export const DELETE_CUSTOM_REPORT_ADMIN_FAILURE = 'DELETE_CUSTOM_REPORT_ADMIN_FAILURE';

export const DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN = 'DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN';

export const TEST_CUSTOM_REPORT_ADMIN = 'TEST_CUSTOM_REPORT_ADMIN';
export const TEST_CUSTOM_REPORT_ADMIN_SUCCESS = 'TEST_CUSTOM_REPORT_ADMIN_SUCCESS';
export const TEST_CUSTOM_REPORT_ADMIN_FAILURE = 'TEST_CUSTOM_REPORT_ADMIN_FAILURE';

export const UPDATE_ROW_ID_TO_SCROLL_ADMIN = 'UPDATE_ROW_ID_TO_SCROLL_ADMIN';

export const RESET_ROW_ID_TO_SCROLL_ADMIN = 'RESET_ROW_ID_TO_SCROLL_ADMIN';

export const CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN = 'CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN';

export const VERIFY_PARAM_TO_EDIT_ADMIN = 'VERIFY_PARAM_TO_EDIT_ADMIN';
export const VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS = 'VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS';
export const VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE = 'VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE';
